import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number = 15) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: initialMinutes,
    seconds: 0,
  })
  const [isUrgent, setIsUrgent] = useState(false)

  useEffect(() => {
    const storageKey = 'quimica_countdown_end'
    const savedEndTime = localStorage.getItem(storageKey)
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
      if (endTime < Date.now()) {
        endTime = Date.now() + initialMinutes * 60 * 1000
        localStorage.setItem(storageKey, endTime.toString())
      }
    } else {
      endTime = Date.now() + initialMinutes * 60 * 1000
      localStorage.setItem(storageKey, endTime.toString())
    }

    const calculateTimeLeft = () => {
      const difference = endTime - Date.now()

      if (difference > 0) {
        const totalMinutes = Math.floor(difference / 1000 / 60)
        setTimeLeft({
          hours: Math.floor(totalMinutes / 60),
          minutes: totalMinutes % 60,
          seconds: Math.floor((difference / 1000) % 60),
        })
        setIsUrgent(totalMinutes < 10)
      } else {
        setTimeLeft({ hours: 0, minutes: 0, seconds: 0 })
        setIsUrgent(true)
      }
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [initialMinutes])

  return { ...timeLeft, isUrgent }
}
